import { isEmpty } from '@/utils';
import { useEffect, useRef } from 'react';
type WSProps = {
  url: string;
  token?: string;
  onOpen: AnyFunc;
  onMessage: AnyFunc;
  onClose?: AnyFunc;
  sendData?: string;
  maxReconnectCallBack?: AnyFunc;
};

const WebsocketCmp = (props: WSProps) => {
  const wsClient: any = useRef(null);
  const _reconnectCount: React.MutableRefObject<number> = useRef(0);
  const autoReconnect: React.MutableRefObject<boolean> = useRef(true);
  const {
    url,
    onOpen,
    onMessage,
    onClose,
    maxReconnectCallBack,
    token,
    sendData,
  } = props;
  useEffect(() => {
    createWebsocket();
    return () => {
      autoReconnect.current = false;
      wsClient.current.close();
      wsClient.current = null;
    };
  }, []);
  useEffect(() => {
    if (wsClient.current.readyState === 1 && !isEmpty(sendData)) {
      wsClient.current.send(sendData);
    }
  }, [sendData]);
  const createWebsocket = () => {
    wsClient.current = token ? new WebSocket(url, token) : new WebSocket(url);
    wsClient.current.onopen = () => {
      onOpen && onOpen(wsClient);
    };
    wsClient.current.onclose = (event: any) => {
      console.log('connection closed');
      if (!autoReconnect.current) {
        return;
      }
      onClose && onClose(event);
      if (_reconnectCount.current > 10) {
        maxReconnectCallBack && maxReconnectCallBack();
        return;
      }
      setTimeout(() => {
        _reconnectCount.current++;
        createWebsocket();
      }, 5000);
    };
    wsClient.current.onmessage = (event: any) => {
      onMessage && onMessage(event.data);
    };
  };
  return null;
};

export default WebsocketCmp;
